import React, { useState, useEffect } from 'react';
import './SummaryModal.css';

const SummaryModal = ({ 
  isOpen, 
  onClose, 
  summaries = [], 
  availableEpubFormat, 
  availablePdfFormat,
  onNavigateToContent 
}) => {
  const [activeTab, setActiveTab] = useState('epub');
  const [pdfSummaries, setPdfSummaries] = useState([]);
  const [epubSummaries, setEpubSummaries] = useState([]);

  useEffect(() => {
    if (availableEpubFormat) {
      setActiveTab('epub');
    } else if (availablePdfFormat) {
      setActiveTab('pdf');
    }
  }, [availableEpubFormat, availablePdfFormat]);

  useEffect(() => {
    const pdf = summaries.filter(item => item.type === 'pdf');
    const epub = summaries.filter(item => item.type === 'epub');
    setPdfSummaries(pdf);
    setEpubSummaries(epub);
  }, [summaries]);

  if (!isOpen) return null;

  const currentSummaries = activeTab === 'epub' ? epubSummaries : pdfSummaries;

  return (
    <div className="summary-modal-backdrop" onClick={onClose}>
      <div className="summary-modal-container" onClick={e => e.stopPropagation()}>
        <div className="summary-modal-header">
          <h2>Sumário</h2>
          <button className="summary-modal-close" onClick={onClose}>×</button>
        </div>
        
        <div className="summary-modal-tabs">
          {availableEpubFormat && (
            <button 
              className={`summary-tab ${activeTab === 'epub' ? 'active' : ''}`}
              onClick={() => setActiveTab('epub')}
            >
              ePUB
            </button>
          )}
          {availablePdfFormat && (
            <button 
              className={`summary-tab ${activeTab === 'pdf' ? 'active' : ''}`}
              onClick={() => setActiveTab('pdf')}
            >
              PDF
            </button>
          )}
        </div>

        <div className="summary-modal-content">
          {currentSummaries.length === 0 ? (
            <p className="summary-empty">Sumário não disponível para este formato</p>
          ) : (
            <ul className="summary-list">
              {currentSummaries.map((item, index) => (
                <li 
                  key={item.uid || index} 
                  className="summary-item"
                  onClick={() => onNavigateToContent(item, activeTab)}
                >
                  <span className="summary-title">{item.title}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default SummaryModal;